import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/future-document-dashboard.scss";
import "assets/css/rtl.css";
import "assets/scss/fd-theme.scss";
import "assets/scss/a11y.scss";

import "./i18n";
import { AuthProvider } from "contexts/AuthContext.js";
import ErrorBoundary from "components/ErrorBoundary.js";
import NetworkStatusProvider from "components/NetworkStatusProvider.js";
import OfflineIndicator from "components/OfflineIndicator.js";
import CookieConsent from "components/CookieConsent.js";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

if (process.env.NODE_ENV === "development") {
  // Capture-phase listeners run before the dev server's full-screen runtime
  // error overlay; the browser still prints the error to the console.
  // Resource errors (e.g. <img onError>) also pass through window capture, so
  // only runtime errors dispatched on window itself are stopped.
  const keepInConsole = (event) => {
    if (event.target === window) event.stopImmediatePropagation();
  };
  window.addEventListener("error", keepInConsole, true);
  window.addEventListener("unhandledrejection", keepInConsole, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <NetworkStatusProvider>
          <Routes>
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/auth/*" element={<AuthLayout />} />
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
          <OfflineIndicator />
          <CookieConsent />
        </NetworkStatusProvider>
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
